import { render, staticRenderFns } from "./NewPwdLessPushRegistered.vue?vue&type=template&id=6b0e2a23&scoped=true"
import script from "./NewPwdLessPushRegistered.vue?vue&type=script&lang=js"
export * from "./NewPwdLessPushRegistered.vue?vue&type=script&lang=js"
import style0 from "./NewPwdLessPushRegistered.vue?vue&type=style&index=0&id=6b0e2a23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e2a23",
  null
  
)

export default component.exports